export default __webpack_public_path__ + "static/media/company-revenue.10773dd4.svg";